var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"$el",class:['relative', 'flex', 'flex-row', _setup.isMap && 'overflow-hidden', 'select-none'],attrs:{"id":`section-title-${_vm.sectionId}`,"dir":_vm.dir},on:{"click":function($event){return _vm.$emit('click', $event)},"dblclick":_setup.tryEditingInline,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('click', $event)},"contextmenu":function($event){$event.preventDefault();return _vm.$emit('open-actions', $event)}}},[_c('div',{class:[
      // Size/shape
      {
        'flex-grow': _setup.isGrid || _setup.isShelf,
      },
      'flex',
      'items-end',
      _setup.isMap && 'overflow-hidden',
      {
        'rounded-s-none tablet-portrait:rounded-s-lg': _setup.isStream || _setup.isMatrix,
        'rounded-ss tablet-landscape:rounded-ss-lg': _setup.isMap,
        'rounded-s-lg': _setup.isGrid || _setup.isShelf,
      },
      _setup.isBeingEdited
        ? {
            'ps-1.25': _setup.isStream || _setup.isMatrix || _setup.isTimeline || _setup.isGrid || _setup.isShelf,
            'ps-1': _setup.isMap,
            'py-[3px]': _setup.isStream || _setup.isMatrix || _setup.isTimeline || _setup.isGrid || _setup.isShelf,
            'py-[1.5px]': _setup.isMap,
          }
        : {
            'ps-5 tablet-portrait:ps-3': _setup.isStream || _setup.isMatrix,
            'ps-5 tablet-portrait:ps-6': _setup.isTimeline,
            'ps-4 tablet-landscape:ps-2.5': _setup.isMap,
            'ps-3': _setup.isGrid || _setup.isShelf,
            'pe-4': _setup.isStream || _setup.isMatrix || _setup.isTimeline || _setup.isGrid || _setup.isShelf,
            'pe-2 tablet-landscape:pe-2.5': _setup.isMap,
            'py-1.75': _setup.isStream || _setup.isMatrix || _setup.isTimeline || _setup.isGrid || _setup.isShelf,
            'py-0.875': _setup.isMap,
          },

      // Default background color
      !_vm.backgroundColor && {
        'bg-light-ui-400': _vm.darkMode === false,
        'bg-dark-ui-400': _vm.darkMode === true,
      },

      // Text
      _setup.twFontClass,
      {
        'text-dark-text-100': _vm.darkMode === false,
        'text-light-text-100': _vm.darkMode === true,
      },
    ],style:({ backgroundColor: _vm.backgroundColor })},[(!_setup.isBeingEdited)?_c('h2',{class:[
        {
          'text-heading-3': _setup.isStream || _setup.isMatrix || _setup.isTimeline || _setup.isGrid || _setup.isShelf,
          'text-body-extra-small': _setup.isMap,
        },
        'font-semibold',
        'break-word-anywhere',
        'whitespace-break-spaces',
        _setup.isMap && 'truncate',
      ],attrs:{"dir":"auto","data-testid":"sectionTitleText"},domProps:{"textContent":_vm._s(_setup.truncatedTitle)}}):_vm._e(),_vm._v(" "),(_setup.isBeingEdited)?[_c('div',{class:[
          'flex',
          {
            'flex-grow': _setup.isGrid || _setup.isShelf,
          },
          'items-center',
          {
            'rounded-xl': _setup.isStream || _setup.isMatrix || _setup.isTimeline || _setup.isGrid || _setup.isShelf,
            'rounded-lg': _setup.isMap,
          },
          {
            'border-2': _setup.isStream || _setup.isMatrix || _setup.isTimeline || _setup.isGrid || _setup.isShelf,
            'border-[1.5px]': _setup.isMap,
          },
          'border-solid',
          {
            'border-grape-500': _vm.darkMode === false,
            'border-canary-500': _vm.darkMode === true,
          },
          {
            'px-1.5 py-0.5': _setup.isStream || _setup.isMatrix || _setup.isTimeline || _setup.isGrid || _setup.isShelf,
            'ps-1.125 pe-[6.5px] py-[.5px]': _setup.isMap,
          },
          {
            'bg-light-ui-100': _vm.darkMode === false,
            'bg-dark-ui-100': _vm.darkMode === true,
          },
        ]},[_c(_setup.MultilineInput,{ref:"titleInput",class:[
            {
              'flex-grow': _setup.isGrid || _setup.isShelf,
            },
            'm-0',
            {
              // Since we truncate the title for Grid (Shelf), we want to limit the height
              // of the input as well. This number here will ensure the height doesn't
              // jump when going from view mode to edit mode.
              'max-h-[208px]': _setup.isGrid || _setup.isShelf,
            },
            {
              'text-heading-3': _setup.isStream || _setup.isMatrix || _setup.isTimeline || _setup.isGrid || _setup.isShelf,
              'text-body-extra-small': _setup.isMap,
            },
            'font-semibold',
            {
              'text-dark-text-100 placeholder-dark-text-200': _vm.darkMode === false,
              'text-light-text-100 placeholder-light-text-200': _vm.darkMode === true,
            },
            _setup.twFontClass,
          ],attrs:{"dir":"auto","required":"","aria-label":_vm.__('Section title'),"cols":(_setup.isStream || _setup.isMatrix || _setup.isTimeline || _setup.isMap) && _setup.currentTitle.length,"data-testid":"surfaceSectionRenameMultilineInput"},on:{"blur":_setup.finishEditingIfFocusTargetIsOutside,"escape":_setup.cancelEditing,"enter":_setup.finishEditing,"paste":function($event){$event.stopPropagation();}},model:{value:(_setup.currentTitle),callback:function ($$v) {_setup.currentTitle=$$v},expression:"currentTitle"}})],1),_vm._v(" "),(!_setup.isMap)?_c(_setup.OzPlainButton,{class:['flex-shrink-0', 'py-1.5'],attrs:{"color-scheme":_setup.OzPlainButtonColorScheme.SecondaryIcon,"size-preset":_setup.OzPlainButtonSizePreset.H32px,"dark-mode":_vm.darkMode,"text":_vm.__('Done')},on:{"blur":_setup.finishEditingIfFocusTargetIsOutside,"click":_setup.finishEditing}}):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('div',{class:[
      // Put the edge underneath so it doesn't cover the main content
      'z-underneath',

      'flex-none',
      'w-3',
      'rounded-[5px]',
      {
        'rounded-s-none': _setup.isStream || _setup.isMatrix || _setup.isTimeline || _setup.isGrid || _setup.isShelf,
        'rounded-s-none rounded-ee-none': _setup.isMap,
      },

      // Default background color
      !_vm.backgroundColor && {
        'bg-light-ui-400': _vm.darkMode === false,
        'bg-dark-ui-400': _vm.darkMode === true,
      },

      {
        'origin-bottom-left': _vm.dir === 'ltr',
        'origin-bottom-right': _vm.dir === 'rtl',
        'origin-bottom-left rtl:origin-bottom-right': _vm.dir === 'auto',
      },
      {
        'skew-x-[10deg]': _vm.dir === 'ltr',
        'skew-x-[-10deg]': _vm.dir === 'rtl',
        'skew-x-[10deg] rtl:skew-x-[-10deg]': _vm.dir === 'auto',
      },
    ],style:({
      backgroundColor: _vm.backgroundColor,
      width: `${_setup.skewedEdgeWidth}px`,
      willChange: 'transform',
    })}),_vm._v(" "),(_vm.xMoreButton && (_setup.isGrid || _setup.isShelf) && !_setup.isBeingEdited)?_c(_setup.OzBaseButton,{class:[
      // Position
      'absolute',
      'top-[3.25px]',

      // Size/shape
      'flex',
      'items-center',
      'justify-center',
      'w-6 h-6.5',
      {
        'rotate-[-10deg]': _vm.dir === 'ltr',
        'rotate-[10deg]': _vm.dir === 'rtl',
        'rotate-[-10deg] rtl:rotate-[10deg]': _vm.dir === 'auto',
      },

      // No background
      'bg-transparent',

      // Focus ring
      'focus-visible:outline-none',
      'rounded-lg',
      'focus-visible:ring-2',
      {
        'ring-grape-500': _vm.darkMode === false,
        'ring-canary-500': _vm.darkMode === true,
      },

      // Icon style
      'leading-none',
      {
        'text-dark-text-200': _vm.darkMode === false,
        'text-light-text-200': _vm.darkMode === true,
      },
      {
        'hover-hover:hover:text-dark-text-100': _vm.darkMode === false,
        'hover-hover:hover:text-light-text-100': _vm.darkMode === true,
      },
      {
        'active:text-grape-500': _vm.darkMode === false,
        'active:text-canary-500': _vm.darkMode === true,
      },
    ],style:({
      // The button is actually positioned relative to the skewed edge
      // but we can't make it a child of the skewed edge `div` because
      // of `z-underneath`.
      // 5 is the border radius of the skewed edge.
      [_vm.dir === 'rtl' ? 'left' : 'right']: `${_setup.skewedEdgeWidth - 5}px`,
    }),attrs:{"id":`section-action-menu-button-${_vm.sectionId}`,"data-testid":`${_vm.title}SectionTitleMoreButton`,"aria-label":_vm.__('Open section actions menu'),"title":_vm.__('Section actions')},on:{"click":function($event){return _vm.$emit('open-actions')}}},[_c(_setup.OzIcon,{attrs:{"name":"more_vertical","size":16}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }